import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AlertMessage {
  type: 'success' | 'error' | 'warning' | 'info';
  text: string;
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  private _alert$ = new BehaviorSubject<AlertMessage | null>(null);
  alert$ = this._alert$.asObservable();

  show(type: AlertMessage['type'], text: string, duration = 3000) {
    this._alert$.next({ type, text });

    if (duration > 0) {
      setTimeout(() => this.clear(), duration);
    }
  }

  success(text: string, duration = 3000) {
    this.show('success', text, duration);
  }

  error(text: string, duration = 3000) {
    this.show('error', text, duration);
  }

  warning(text: string, duration = 3000) {
    this.show('warning', text, duration);
  }

  info(text: string, duration = 3000) {
    this.show('info', text, duration);
  }

  clear() {
    this._alert$.next(null);
  }
}
